<template>
  <transition name="el-zoom-in-top" @after-leave="doDestroy">
    <div ref="popper" class="el-popper" v-show="showPopper">
      <slot></slot>
    </div>
  </transition>
</template>
<script>
  import Popper from 'element-ui/lib/utils/vue-popper'

  export default {
    mixins: [Popper],
    name: 'WhatyDropdown',
    props: {
      referenceName: {
        type: String
      },
      placement: {
        default: 'bottom-start'
      },
      boundariesPadding: {
        default: 0
      },
      popperOptions: {
        default() {
          return {
            gpuAcceleration: false
          }
        }
      },
      visibleArrow: {
        default: true
      },
      appendToBody: {
        type: Boolean,
        default: true
      }
    },
    mounted() {
      this.referenceElm = this.$parent.$refs[this.referenceName]
      // this.$parent.popperElm = this.popperElm = this.$el;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/whaty-dropdown/whaty-dropdown.vue